export default __webpack_public_path__ + "static/media/logo_cempre.4439a119.png";